<template>
  <div class="py-3 bg-transparent">
    <div class="notification-header mb-8">
      <div class="flex items-center justify-start gap-8">
        <span
          class="cursor-pointer notification__inactive relative"
          :class="{ notification__active: notificationType === 'all-notifications' }"
          id="all-notifications"
          @click="notificationType = 'all-notifications'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Notifications</h4>
          <!-- Yellow Dot Badge (combines logic of unread items + pending invites) -->
          <span 
            v-if="unreadChatCount > 0 || unreadCoachCount > 0 || pendingAdminInvites.length > 0" 
            class="absolute w-3 h-3 rounded-full border-2 border-white"
            style="background-color: #F2C244; top: -2px; right: -8px;"
          ></span>
        </span>
        <!-- <span
          class="cursor-pointer notification__inactive"
          :class="{
            notification__active: notificationType === 'learning-actions',
          }"
          id="learning-actions"
          @click="notificationType = 'learning-actions'"
          v-if="appSubscriptions.alex"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">{{ $t('orgDashboard.userDashboard.notifications.learningActions') }}</h4>
        </span>
        
        <span
          v-if="appSubscriptions.journey && galaQuests"
          class="cursor-pointer notification__inactive"
          :class="{
            notification__active: notificationType === 'journey-quests',
          }"
          id="journey-quests"
          @click="notificationType = 'journey-quests'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Journey Quests</h4>
        </span>

        <span
          class="cursor-pointer notification__inactive"
          :class="{ notification__active: notificationType === 'invites' }"
          id="invites"
          @click="notificationType = 'invites'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">{{ $t('orgDashboard.userDashboard.notifications.invites') }}</h4>
        </span>

        <span
          class="cursor-pointer notification__inactive relative"
          :class="{ notification__active: notificationType === 'chat' }"
          id="chat"
          @click="notificationType = 'chat'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Mentions</h4>
          <span 
            v-if="unreadChatCount > 0" 
            class="absolute w-3 h-3 rounded-full border-2 border-white"
            style="background-color: #F2C244; top: -2px; right: -8px;"
          ></span>
        </span>

        <span
          class="cursor-pointer notification__inactive relative"
          :class="{ notification__active: notificationType === 'coach-invites' }"
          id="coach-invites"
          @click="notificationType = 'coach-invites'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Coach Invites</h4>
          <span 
            v-if="unreadCoachCount > 0" 
            class="absolute w-3 h-3 rounded-full border-2 border-white"
            style="background-color: #F2C244; top: -2px; right: -8px;"
          ></span>
        </span> -->

      </div>
    </div>

    <div class="notification__container w-full h-full mt-4">
      <div v-if="loadingSkeleton" class="">
        <vs-row class="px-3 py-3">
          <vs-row
            v-for="i in 5"
            :key="i"
            class="p-16 rounded-lg my-2 bg-slate-300 animate-pulse"
          />
        </vs-row>
      </div>

      <div v-if="!loadingSkeleton" class="rounded-lg overflow-hidden">
        
        <!-- Learning Actions Content (Unchanged) -->
        <div v-if="notificationType === 'learning-actions' && appSubscriptions.alex">
          <!-- validation notification content... -->
          <div v-if="items && items.length > 0 && !loadingSkeleton" class="flex flex-col gap-1">
             <div
              v-for="(item, index) in items"
              :key="item.itemId"
              :id="item.itemId"
              style="display: flex"
              class="items-center justify-between w-full bg-white py-6 px-4"
              :class="{
                hidden: !(
                  (item.status === 'done' ||
                    item.feedLibraryItemStatus === 'done') &&
                  item.libraryItemValidationData
                ),
              }"
            >
              <div class="flex w-full gap-4">
                <div class="w-24 h-24 overflow-hidden rounded-lg">
                  <img
                    class="w-full h-full object-cover"
                    :src="item.imageUrl"
                    @error="randomFeedImage"
                  />
                </div>
                <div class="flex flex-col gap-4 w-full justify-between">
                  <div class="flex flex-row w-full gap-2">
                    <h5 class="flex text-left w-full text-lg">
                      {{ item.title | title }}
                    </h5>
                    <!-- Dropdown Code (Unchanged) -->
                  </div>
                  <!-- Tokens Code (Unchanged) -->
                </div>
              </div>
            </div>
          </div>

          <div
            class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
            v-if="!loadingSkeleton && items.length === 0"
          >
            <img class="lg:w-4/12 w-64" src="@/assets/images/temp-img/empty-notification.svg" />
            <div class="flex flex-col gap-6 justify-center items-center">
              <p class="text-lg text-center font-semibold flex gap-2 flex-col">
                {{ $t('orgDashboard.userDashboard.notifications.noNotifications') }}
              </p>
            </div>
          </div>
        </div>

        <!-- Journey Quests Content (Unchanged) -->
        <div v-if="notificationType === 'journey-quests' && appSubscriptions.journey" class="bg-white p-4 rounded-lg">
           <!-- Journey code here -->
        </div>

        <div v-if="notificationType === 'all-notifications'" class="p-4">
          
          <div v-if="pendingAdminInvites.length > 0 || chatNotifications.length > 0 || coachNotifications.length > 0" class="flex flex-col gap-3">
            
            <!-- 1. Admin Invites (Simple View) -->
            <div v-for="(org, index) in pendingAdminInvites" :key="'admin-' + index"
                class="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex items-start gap-4 transition-all hover:shadow-md">
              <div class="w-10 h-10 rounded-full flex items-center justify-center text-white shrink-0" style="background-color: #F2C244;">
                  <feather-icon icon="BriefcaseIcon" svgClasses="h-5 w-5 text-white" />
              </div>
              <div class="flex-1 text-left overflow-hidden">
                <div class="flex justify-between items-center">
                   <!-- Placeholder for date if you have it, otherwise leaves space -->
                   <p class="text-xs font-semibold text-gray-400"></p> 
                 </div>
                <p class="text-sm text-gray-700 font-medium leading-relaxed my-2">
                  You have been invited to join <span class="font-bold text-gray-900">{{ org.organization[0].name }}</span>.
                </p>
                
                <!-- UPDATED FLEX CONTAINER: Pushes button to right -->
                <div class="flex items-center justify-between mt-3">
                  <span class="text-xs bg-gray-100 px-2 py-1 rounded border text-gray-500">
                    Role: <span class="font-bold text-slate-900">Admin</span>
                  </span>
                  
                  <!-- UPDATED BUTTON TEXT -->
                  <vs-button size="small" color="success" type="filled" @click.stop="acceptAdminOrgInvite(org._id, org.organization[0].slug || org.organization[0]._id)">
                    Accept Invite
                  </vs-button>
                </div>
                
              </div>
            </div>

            <!-- 2. Mentions & Session Requests -->
            <template v-for="notif in chatNotifications">
              
              <!-- A) OFFER / SESSION REQUEST -->
              <div v-if="notif.role_name === 'Session Request'" :key="'offer-' + notif.id"
                  class="bg-white p-4 rounded-lg border border-indigo-200 shadow-sm flex items-start gap-4 transition-all hover:shadow-md cursor-default">
                
                <!-- Icon -->
                <div class="w-10 h-10 rounded-full flex items-center justify-center text-white shrink-0" style="background-color: #6366f1;">
                    <feather-icon icon="CalendarIcon" svgClasses="h-5 w-5 text-white" />
                </div>
                
                <!-- Content -->
                <div class="flex-1 text-left overflow-hidden">
                  <div class="flex justify-between items-center">
                    <p class="text-xs font-semibold text-gray-400">{{ formatChatDate(notif.created_at) }}</p>
                    <span class="text-xs bg-indigo-50 text-indigo-600 px-2 py-1 rounded font-semibold border border-indigo-100">
                      Offer Request
                    </span>
                  </div>
                  
                  <p class="text-sm text-gray-800 font-medium leading-relaxed my-2">
                    {{ notif.message }}
                  </p>
                  
                  <div class="mt-2 flex items-center gap-2">
                    <span class="text-xs text-gray-500 font-medium flex items-center gap-1">
                      <feather-icon icon="MailIcon" svgClasses="w-3 h-3" /> The organization will contact you via email to finalize details.
                    </span>
                  </div>
                </div>
              </div>

              <!-- B) STANDARD MENTIONS -->
              <div v-else :key="'mention-' + notif.id"
                  @click="navigateToNote(notif)"
                  class="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex items-start gap-4 transition-all hover:shadow-md cursor-pointer">
                
                <div class="w-10 h-10 rounded-full flex items-center justify-center text-white shrink-0" style="background-color: #F2C244;">
                    <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5 text-white" />
                </div>
                <div class="flex-1 text-left overflow-hidden">
                  <div class="flex justify-between items-center">
                    <p class="text-xs font-semibold text-gray-400">{{ formatChatDate(notif.created_at) }}</p>
                  </div>
                  <p class="text-sm text-gray-700 font-medium leading-relaxed my-2">
                    <span class="font-bold text-gray-900">{{ notif.sender_name }}</span> mentioned you in 
                    <span class="font-bold text-gray-900">{{ notif.role_name }}</span> ({{ notif.org_name }}):
                  </p>
                  <p class="text-sm text-gray-600 bg-gray-50 p-3 rounded-md border border-gray-200 truncate">
                    "{{ notif.message }}"
                  </p>
                </div>
              </div>

            </template>

            <!-- 3. Coach Invites -->
            <div v-for="notif in coachNotifications" :key="'coach-' + notif.plan_id"
                class="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex items-start gap-4 transition-all hover:shadow-md">
              <div class="w-10 h-10 rounded-full flex items-center justify-center text-white shrink-0" style="background-color: #F2C244;">
                  <feather-icon icon="UserIcon" svgClasses="h-5 w-5 text-white" />
              </div>
              <div class="flex-1 text-left overflow-hidden">
                <div class="flex justify-between items-center">
                  <p class="text-xs font-semibold text-gray-400">{{ formatChatDate(notif.created_at) }}</p>
                </div>
                <p class="text-sm text-gray-700 font-medium leading-relaxed my-2">
                  You have been added to the board <span class="font-bold text-gray-900">{{ notif.plan_name }}</span> under 
                  <span class="font-bold text-gray-900">{{ notif.org_name }}</span>.
                </p>
                <div class="flex items-center justify-between mt-3">
                  <span class="text-xs bg-gray-100 px-2 py-1 rounded border text-gray-500">
                    Role: <span class="font-bold text-slate-900">{{ notif.relationship_type }}</span>
                  </span>
                  <vs-button size="small" color="primary" type="filled" @click.stop="acceptAndRedirectToCoach(notif)">
                    Access Coach
                  </vs-button>
                </div>
              </div>
            </div>

          </div>

          <!-- Empty State -->
          <div v-else class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8">
            <img class="lg:w-3/12 w-64" src="@/assets/images/temp-img/empty-notification.svg" />
            <div class="flex flex-col gap-6 justify-center items-center">
              <p class="text-xl text-center flex gap-2 flex-col font-semibold text-black">
                No notifications right now!
                <span class="font-normal text-slate-600 text-base">You're all caught up.</span>
              </p>
            </div>
          </div>
        </div>
        <div
          class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
          v-else-if="
            !appSubscriptions.coach &&
            !appSubscriptions.alex &&
            !appSubscriptions.journey &&
            notificationType !== 'invites' &&
            notificationType !== 'chat'
          "
        >
          <img class="lg:w-3/12 w-64" src="@/assets/images/temp-img/empty-notification.svg" />
          <div class="flex flex-col gap-6 justify-center items-center">
            <p class="text-xl text-center flex gap-2 flex-col font-semibold text-black">
              No notifications found!
              <br />
              <span class="font-normal text-slate-600 text-base">Assign yourself tasks through your organization.</span>
            </p>
            <router-link to="/user/my-organizations" class="py-2 px-4 bg-primary text-slate-950 w-fit text-lg rounded-lg font-semibold">Go to Organizations</router-link>
          </div>
        </div>
      </div>

      <div
        @click="claimAllRewards()"
        v-if="
          notificationType === 'learning-actions' &&
          !loadingSkeleton &&
          claimAllBtn &&
          items &&
          items.length > 0
        "
        class="sticky bottom-0 claim-all-btn p-4 flex justify-end"
      >
        <div class="max-w-max btn-claim-all text-lg font-medium rounded-lg py-2 px-4 cursor-pointer">
          Read and Claim All
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import appSteps from "@/assets/data/app-flow";
import gsap from "gsap";
import constants from "@/constants.js";

// Make sure this points to your Python backend!
const PYTHON_API_URL = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      notificationType: "",
      mergedItems: [],
      items: [],
      loadingSkeleton: true,
      coachUserData: {},
      growthPlan: [],
      selected: [],
      fill: { gradient: ["#4D927F", "#B7DA64"] },
      receivedCoachData: false,
      claimAllBtn: false,
      CCD: this.$t("coach.addNewSkill.data"),
      learningActionItems: false,
      constants,
      activeIndex: null,
      journeyQuests: {},
      activeStep: {},
      completedSteps: 0,
      journeyIndex: 1,
      galaQuests: false,
      questQ1: "",
      questQ2: "",
      appSteps,
      
      // NEW CHAT VARIABLES
      chatNotifications: [],
      coachNotifications: [],
      unreadCoachCount: 0,
      unreadChatCount: 0,
      pollingInterval: null,
    };
  },
  beforeCreate() {
    this.$store.commit("UPDATE_PRIMARY_COLOR", "#F2C244");
    this.$vs.theme({ primary: "#F2C244" });
  },
  created() {
    this.startNotificationPolling();
    // Fetch data immediately on hard reload
    if (this.notificationType === 'all-notifications' || !this.notificationType) {
      this.loadAllData();
    }
  },
  
  // This fires every time you navigate to this page if Vue is caching it
  activated() {
    if (this.notificationType === 'all-notifications') {
      this.loadAllData();
    }
  },
  mounted() {
    if (this.appSubscriptions && this.appSubscriptions.alex) {
      this.notificationType = "learning-actions";
    } else {
      this.notificationType = "all-notifications";
    }
  },
  
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  
  components: {
    VuePerfectScrollbar,
  },
  
  computed: {
    myOrganizations() { return this.$store.state.organization.myOrganizations; },
    pendingAdminInvites() {
      if (!this.myOrganizations || !this.myOrganizations.subOrgs) return [];
      return this.myOrganizations.subOrgs.filter(org => org.status !== 'active' && org.status !== 'DEACTIVATED');
    },
    userOrganizations() { return this.$store.state.users.userOrganizations; },
    userData() { return this.$store.state.users.data; },
    userOrganization() { return this.$store.state.users.selectedOrganization; },
    notificationPanelPopup() { return this.$store.state.modals.notificationPanelPopup; },
    appSubscriptions() { return this.$store.state.users.appSubscriptions; },
    journeySteps() { return appSteps.flow.journey.steps; },
  },
  watch: {
    $route: {
      handler() {
        if (this.notificationType === 'all-notifications') {
          this.fetchInvitesData();
          this.fetchChatNotifications();
          this.fetchCoachInvitations();
        }
      }
    },

    notificationType: {
      immediate: true,
      handler(newVal) {
        this.loadingSkeleton = true;
        
        if (newVal === "learning-actions") {
          this.fetchUserInterestedItems();
        } else if (newVal === "journey-quests") {
          this.getJourneyQuests();
        } else if (newVal === "growth-plans") {
          this.fetchGrowthPlans();
        } else if (newVal === "all-notifications") { 
          
          // Fetch all data for the combined tab
          this.fetchInvitesData();
          this.fetchChatNotifications();
          this.fetchCoachInvitations();
          
          // Fallback: Safely turn off the skeleton and mark as read after a short delay
          // This guarantees the screen won't stay blank even if an API is slow
          setTimeout(() => {
             this.loadingSkeleton = false;
             this.markChatNotificationsRead();
          }, 500);
          
        }
      },
    },

    items: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          let claimItems = [];
          for (let i = 0; i < newVal.length; i++) {
            if ((newVal[i].reviewStatus && !newVal[i].tokenClaimed) || (newVal[i].libraryItemValidationData && (newVal[i].status === "done" || newVal[i].feedLibraryItemStatus === "done"))) {
              this.learningActionItems = true;
            }
            if (((newVal[i].reviewStatus && newVal[i].reviewStatus.toLowerCase() === "accepted") || newVal[i].feedItemUserValidationStatus) && !newVal[i].tokenClaimed) {
              claimItems.push(newVal[i]);
            }
            this.claimAllBtn = claimItems.length > 0 ? true : false;
          }
        }
      },
    },

    notificationPanelPopup: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.notificationType === "learning-actions") {
            this.fetchUserInterestedItems();
          }
        }
      },
    },

    userOrganizations: {
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          this.galaQuests = newVal[i].organizationData.slug === "gala" ? true : false;
        }
      },
      deep: true,
      immediate: true,
    },

    appSubscriptions: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal.alex) {
          this.notificationType = "learning-actions";
        } else if (newVal.journey) {
          // this.notificationType = "journey-quests";
        } else {
          this.notificationType = "all-notifications"; 
          this.loadingSkeleton = false;
        }
      },
    }
  },
  methods: {
    loadAllData() {
      this.loadingSkeleton = true;
      this.fetchInvitesData();
      this.fetchChatNotifications();
      this.fetchCoachInvitations();
      
      setTimeout(() => {
        this.loadingSkeleton = false;
        if (this.notificationType === 'all-notifications') {
          this.markChatNotificationsRead();
        }
      }, 500);
    },
    navigateToNote(notification) {
      if (notification.org_slug) {
        // Navigate to the organization chart where the note was left
        window.location.href = `/organization/${notification.org_slug}/value`;
      }
    },
    startNotificationPolling() {
      // Clear any pre-existing interval to prevent duplicates
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
      
      // Poll the backend every 30 seconds for real-time updates
      this.pollingInterval = setInterval(() => {
        this.fetchCoachInvitations();
        this.fetchChatNotifications();
      }, 30000); 
    },
    // --- NEW CHAT METHODS ---
    async fetchChatNotifications() {
      try {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
        const userId = this.$store.state.auth.user._id;
        
        const res = await fetch(`${PYTHON_API_URL}/api/users/${userId}/notifications`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (res.ok) {
          const data = await res.json();
          this.chatNotifications = data.data || [];
          this.unreadChatCount = this.chatNotifications.filter(n => n.is_read === 0 || n.is_read === false).length;
        }
      } catch (err) {
        console.error("Failed to fetch chat notifications:", err);
      }
    },

    async fetchCoachInvitations() {
      try {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
        const userId = this.$store.state.auth.user._id;
        
        const res = await fetch(`${PYTHON_API_URL}/api/v2/users/${userId}/coach-invitations`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (res.ok) {
          const data = await res.json();
          this.coachNotifications = data.data || [];
          // Calculate invitations based on local unread tracking if needed.
          // Currently sets the badge to match unread status on the layout.
          if (this.notificationType !== "coach-invites") {
            this.unreadCoachCount = this.coachNotifications.length;
          } else {
            this.unreadCoachCount = 0;
          }
        }
      } catch (err) {
        console.error("Failed to fetch coach notifications:", err);
      }
    },

    async acceptAndRedirectToCoach(notification) {
      try {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
        const userId = this.$store.state.auth.user._id;
        const email = this.$store.state.auth.user.email;
        
        // 1. Sync User to MySQL and Feathers before transitioning
        await fetch(`${PYTHON_API_URL}/api/v2/coach/sync-user`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: userId,
            org_id: notification.org_id,
            email: email
          })
        });
        
        // 2. Perform Single Sign-On Transition
        this.toCoach();
      } catch (err) {
        console.error("SSO sync or redirection failed:", err);
        this.toCoach(); // Fallback transition attempt
      }
    },
    
    async markChatNotificationsRead() {
      if (this.unreadChatCount === 0) return;
      try {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
        const userId = this.$store.state.auth.user._id;
        
        await fetch(`${PYTHON_API_URL}/api/users/${userId}/notifications/read`, {
          method: 'PATCH',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        this.unreadChatCount = 0; // Clear the yellow dot instantly
        
        // Mark local array as read
        this.chatNotifications.forEach(n => n.is_read = 1);
        
      } catch (err) {
        console.error("Failed to mark chat notifications read:", err);
      }
    },

    formatChatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr + "Z"); // Assuming Python returns UTC
      return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    // ------------------------

    mergeArrays(array1, array2) {
      const merged = [];
      const idSet = new Set();
      if (array1.length > 0) {
        for (const item of array1) {
          merged.push(item);
          idSet.add(item.feedItemId);
        }
      }
      if (array2.length > 0) {
        for (const item of array2) {
          if (idSet.has(item.itemId)) {
            const existingItem = merged.find((el) => el.feedItemId === item.itemId);
            Object.assign(existingItem, item);
          } else {
            merged.push(item);
            idSet.add(item.itemId);
          }
        }
      }
      for (let i = 0; i < merged.length; i++) {
        if (merged[i].libraryItemValidationData && (merged[i].status === "done" || merged[i].feedLibraryItemStatus === "done")) {
          this.mergedItems.push(merged[i]);
        }
      }
    },
    fetchInvitesData() {
      const payload = {
        email: this.$store.state.auth.user.email,
        userId: this.$store.state.auth.user._id,
      };
      this.$store.dispatch("organization/fetchAllMyOrganizations", payload).then(() => { this.loadingSkeleton = false; });
    },
    acceptAdminOrgInvite(adminId, orgIdOrSlug) {
      this.$store.dispatch("organization/acceptAdminOrgInvite", { adminId })
        .then(() => { 
          if (orgIdOrSlug) {
            window.location.href = `/organization/${orgIdOrSlug}/home`;
          } else {
            window.location.href = "/user/my-organizations"; // Fallback safe-guard
          }
        })
        .catch((err) => {
          console.error("Failed to accept invitation:", err);
        });
    },
    manageOrganization(idOrSlug) {
      window.location.href = `/organization/${idOrSlug}/home`;
    },
    fetchUserInterestedItems() {
      if (this.notificationType === "learning-actions") {
        this.items = [];
        this.mergedItems = [];
        this.loadingSkeleton = true;
        this.$store
          .dispatch("alex/getRedirectItemsCount", { gtbrddUserId: this.$store.state.auth.user._id, source: ["LIBRARY"] })
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              let itemIds = [];
              let array1 = res.data;
              for (let element of res.data) {
                if (element.libraryItemValidationData && element.feedItemId !== null) {
                  if (!itemIds.includes(element.feedItemId)) {
                    itemIds.push(element.feedItemId);
                  }
                }
              }
              this.$store
                .dispatch("feed/fetchBulkItemDetails", { itemId: itemIds, getboardedId: this.$store.state.auth.user._id })
                .then((res) => {
                  let array2 = [];
                  if (res && res.length > 0 && typeof res !== "string") {
                    array2 = res;
                    this.mergeArrays(array1, array2);
                    this.items = this.mergedItems;
                  } else {
                    this.mergeArrays(array1, array2);
                    this.items = this.mergedItems;
                  }
                })
                .catch((err) => {
                  this.mergeArrays(array1, []);
                  this.items = this.mergedItems;
                });
              if (res.data.length > 0) {
                this.loadingSkeleton = true;
                let fetchCustomLibraryItemPromises = [];
                for (let a = 0; a < res.data.length; a++) {
                  if (res && res.data && res.data[a] && res.data[a].feedItemId && res.data[a].feedItemId.includes("altf")) {
                    const payload = { orgId: "6512fc951aa789001abd5ed4", itemId: res.data[a].feedItemId, userId: this.$store.state.auth.user._id };
                    let item = res.data[a];
                    let promise = this.$store
                      .dispatch("alex/fetchCustomLibraryItem", payload)
                      .then((res) => {
                        if (res.data && item.libraryItemValidationData && (res.data.status === "done" || res.data.feedLibraryItemStatus === "done")) {
                          this.items.push({ ...res.data, ...item });
                        }
                      }).catch((err) => {});
                    fetchCustomLibraryItemPromises.push(promise);
                  }
                }
                Promise.all(fetchCustomLibraryItemPromises).then(() => { this.loadingSkeleton = false; }).catch((err) => {});
              } else { this.loadingSkeleton = false; }
            }
          })
          .catch((err) => { this.loadingSkeleton = false; });
      }
    },
    randomFeedImage(e) {
      let i = 15;
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[Math.floor(Math.random() * i)]}.png`));
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${item.itemId}&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${this.userOrganization.organizationId}&redirectsourceid=USER_DASHBOARD`;
      if (link && !this.queries && !this.disableLink) { window.open(link, "_blank"); }
    },
    validateItem(item) {
      event.stopPropagation();
      let itemData = [{ id: item.itemId, slug: this.userOrganization.organizationData.slug, vType: item.libraryItemValidationData.validationType, token: this.$store.state.auth.accessToken, orgId: item.libraryItemValidationData.gtbrddOrganizationId }];
      this.$parent.itemData = itemData;
      this.$parent.activeAlex = true;
    },
    fetchGrowthPlans() {
      this.receivedCoachData = false;
      for (let i = 0; i < this.userOrganizations.length; i++) {
        this.$store
          .dispatch("users/getGrowthPlans", { userId: this.userData._id, orgId: this.userOrganizations[i].organizationId })
          .then((res) => {
            if (res && res.data) { this.growthPlan = res.data; }
            if (res.code === "USER_IS_COACH") { return this.getCoachUserData(); }
          }).catch((err) => {}).finally(() => { this.receivedCoachData = true; this.loadingSkeleton = false; });
      }
    },
    getJourneyQuests() {
      this.loadingSkeleton = true;
      this.$store
        .dispatch("users/fetchJourneyQuests", { gtbrddUserId: this.userData._id })
        .then((res) => {
          this.journeyQuests = res.data;
          for (let key in res.data) { this.activeSelectedStep(res.data[key], key); break; }
        }).catch((err) => {}).finally(() => { this.loadingSkeleton = false; });
    },
    getCoachUserData() {
      this.$store.dispatch("coach/getCoachUserData", this.userData._id).then((res) => { this.coachUserData = res; }).catch((err) => {}).finally(() => { this.receivedCoachData = true; setTimeout(() => { this.loadingSkeleton = false; }, 1000); });
    },
    toCoach() {
      let user = this.userData.email.slice(0, this.userData.email.indexOf("@"));
      window.location.href = `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
    },
    claimReward(item, index) {
      event.stopPropagation();
      if (!item.tokenClaimed) {
        const payload = { gtbrddOrganizationId: item.libraryItemValidationData.gtbrddOrganizationId, gtbrddUserId: this.userData._id, libraryItemId: item.itemId };
        this.$store
          .dispatch("alex/claimRewards", payload)
          .then((res) => {
            if (res && res.data && res.data._id) {
              for (let i = 0; i < this.items.length; i++) {
                let itemsClaimedCount = 0;
                let itemsToBeClaimedCount = 0;
                if (this.items[i].tokenClaimed) { itemsClaimedCount = itemsClaimedCount + 1; }
                if (this.items[i].reviewStatus) { itemsToBeClaimedCount = itemsToBeClaimedCount + 1; }
                if (itemsClaimedCount === itemsToBeClaimedCount) { this.claimAllBtn = false; }
              }
              this.activeIndex = index;
              setTimeout(() => {
                const ipGold = document.getElementById(`${item.libraryItemValidationData.gtbrddOrganizationId.slice(-5)}-reward-gold`).getBoundingClientRect();
                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_GOLD", { top: ipGold.top, bottom: ipGold.bottom, left: ipGold.left, right: ipGold.right });
                const ipXp = document.getElementById("reward-xp").getBoundingClientRect();
                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_XP", { top: ipXp.top, bottom: ipXp.bottom, left: ipXp.left, right: ipXp.right });
                this.$store.commit("animation/SET_GOLD_ID", item.libraryItemValidationData.gtbrddOrganizationId.slice(-5));
                this.$store.commit("animation/SET_ANIMATION_STATUS", true);
              }, 50);
              item.libraryItemValidationData.tokens.forEach((tokenObj) => { tokenObj["organizationId"] = item.libraryItemValidationData.gtbrddOrganizationId; });
              this.$store.commit("users/UPDATE_USER_TOKENS", item.libraryItemValidationData.tokens);
              this.items[index].tokenClaimed = true;
              this.$forceUpdate();
            }
          }).catch((err) => {});
      }
    },
    claimAllRewards() {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].reviewStatus || this.items[i].feedItemUserValidationStatus) { this.claimReward(this.items[i], i); }
      }
    },
    getCompentencyData(id) {
      const characteristicId = id.split("-")[0];
      const competencyId = id.split("-")[1];
      const competencies = this.CCD[characteristicId].competencies;
      return competencies[competencyId];
    },
    getTokenValue(tokens, key) {
      if (tokens) {
        let token = tokens.find((token) => token.key === key);
        return token ? token.value : 0;
      }
    },
    getJourneyProgress(steps) {
      let totalSteps = steps.length;
      let completedSteps = 0;
      for (let i = 0; i < steps.length; i++) {
        if (steps[i].completionPercentage === 100) { completedSteps = completedSteps + 1; }
      }
      return (100 * completedSteps) / totalSteps;
    },
    activeSelectedStep(journeyQuest, i) {
      this.activeStep = journeyQuest.steps;
      let completedSteps = 0;
      for (let i = 0; i < this.activeStep.length; i++) {
        if (this.activeStep[i].completionPercentage === 100) { completedSteps = completedSteps + 1; }
      }
      this.completedSteps = completedSteps;
      this.journeyIndex = i === "q1" ? 1 : 2;
    },
    getGoalActiveDate(quest) {
      let boardId = quest === "q1" ? "63f7ac7c99ee08001de8c9b0" : "64f48a69c433ae00195dbeb0";
      this.$store
        .dispatch("boards/fetchCurrentBoardUserDetails", { userId: this.userData._id, boardId: boardId })
        .then((res) => {
          if (res && res.data && res.data[0] && res.data[0].createdAt) {
            const timestamp = new Date(res.data[0].createdAt);
            const day = timestamp.getDate();
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[timestamp.getMonth()];
            const year = timestamp.getFullYear();
            const formattedDate = `${day} ${month} ${year}`;
            if (quest === "q1") { this.questQ1 = formattedDate; } else if (quest === "q2") { this.questQ2 = formattedDate; }
          }
        }).catch((err) => {});
    },
    getStepName(stepId) {
      let step = this.journeySteps.find((step) => step.id === stepId);
      return step ? step.title : stepId;
    },
    skipValidation(item) {
      const payload = { gtbrddUserId: this.userData._id, gtbrddOrganizationId: item.libraryItemValidationData.gtbrddOrganizationId, feedItemId: item.itemId };
      this.$store
        .dispatch("alex/skipItemValidation", payload)
        .then((res) => {
          if (res && res.data && res.data._id) {
            this.$refs.itemOptions[0].click();
            this.$vs.notify({ title: "Validation skipped successfully !", iconPack: "feather", icon: "icon-check-circle", color: "success" });
            const tl = gsap.timeline({ defaults: { duration: 0.5, ease: "rough", repeat: 0 } });
            tl.fromTo("#" + item.itemId, 0.5, { opacity: 1, display: "flex" }, { opacity: 0, display: "flex" });
            tl.fromTo("#" + item.itemId, 0.5, { opacity: 0, display: "none" }, { opacity: 0, display: "none" });
          }
        }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  &__container {
    z-index: 10;
    .notification-header {
      position: sticky;
      top: 0rem;
      z-index: 10;
      background: #fff;
      .types { margin: 0 -1em; }
    }
    .token-box {
      border-radius: 0.5rem;
      background: #f2f4f7;
      border: 1px solid #d0d5dd;
      h6 {
        color: #676767 !important;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        font-weight: 500;
        right: 0;
        bottom: -10px;
      }
    }
    .btn {
      &-claim { background: #25cc9a1a; color: #25cc9a; &-all { background: #f2f4f7; color: #98a2b3; } }
      &-validate { background: #f8c62c; color: #fff; }
    }
    .claim-all-btn { background: #fff; }
    .heading { &-gray { color: #808080 !important; } }
    .border { border: 2px solid #efefef; }
  }
  &__inactive { h4 { color: #5e5b5b !important; font-weight: 400; } }
  &__active { h4 { color: #101828 !important; font-weight: 600; } }
}

.journey__notification__card {
  border-radius: 0.75rem;
  background: #7a5af8;
  .reward__container { border-radius: 0.375rem; background: rgba(255, 255, 255, 0.5); }
  .progress { width: 100%; -webkit-appearance: none; appearance: none; border-radius: 10px; border: 2px solid #fff; height: 15px; background-color: #fff; text-align: left; }
  progress::-webkit-progress-bar { background-color: #ffffff; border-radius: 10px; }
  progress::-webkit-progress-value { background-color: #25cc9a !important; border-radius: 10px; place-self: start; }
  progress::-moz-progress-bar { background-color: #25cc9a !important; border-radius: 10px; }
}

$bg: #fba62742;
$color: #fba727;

.icon-bg { background-color: $bg; }
.skills-btn { color: $color !important; background: $bg; }
.vx-card ::v-deep .vx-card__body { padding: 0; }
.opacity { opacity: 0.075; }
.webkit-width { width: -webkit-fill-available; }
.circle ::v-deep .percent-text { font-size: 15px !important; }
.stick-top { top: 6em; }
.vs-con-table ::v-deep .vs-table--tbody-table { min-width: 100%; }
.vs-con-table { width: 100%; }
.add-btn { color: #fff; background: $color; border-radius: 5em; }
.skeleton { background: #808080; animation: flicker-light 1s infinite alternate; }

@keyframes flicker-light {
  0% { opacity: 0; }
  100% { opacity: 0.2; }
}

@media screen and (max-width: 991px) {
  .vs-con-table ::v-deep .vs-table--content { width: 100%; }
}

.ps ::v-deep .ps__scrollbar-y-rail { z-index: 100; }

.progress__container {
  background-color: rgba(255, 215, 97, 0.3); width: 100%; min-height: 15rem; border-radius: 1rem; display: flex; justify-content: center; gap: 2rem; align-items: center; text-align: left;
  &__info {
    display: flex; flex-direction: column; justify-content: center; align-items: center; margin-left: 1.5rem; position: relative;
    img { width: 3rem; height: auto; }
    span { color: #ffb70c; font-size: 1rem; font-weight: 600; height: fit-content; position: absolute; margin-top: 5.5rem; }
  }
  &__bar {
    width: 100%; margin-right: 1.5rem; display: flex; flex-direction: row; justify-content: space-between; align-content: center; height: 10rem; position: relative;
    img { width: 2rem; place-self: start; }
    .odd { place-self: start; }
    .even { place-self: end; }
    .progress { width: 100%; -webkit-appearance: none; appearance: none; border: none; border-radius: 10px; height: 15px; background-color: #fcde98; place-self: center; position: absolute; text-align: left; }
    progress::-webkit-progress-bar { background-color: #fcde98; border-radius: 10px; }
    progress::-webkit-progress-value { background-color: #25cc9a !important; border-radius: 10px; }
    progress::-moz-progress-bar { background-color: #25cc9a !important; border-radius: 10px; }
  }
}

@media screen and (max-width: 530px) {
  .notification {
    &__container { left: 0; width: 100%; }
  }
}
</style>